import * as m from "~/paraglide/messages.js";
import type { ServicePage } from "./types";

export function getAgentsPage(): ServicePage {
  return {
    art: {
      kind: "routing",
      steps: [
        {
          detail: m.svc_agents_art_1_detail(),
          icon: "gmail",
          label: m.svc_agents_art_1_label(),
          state: m.svc_agents_art_1_state(),
        },
        {
          detail: m.svc_agents_art_2_detail(),
          icon: "hubspot",
          label: m.svc_agents_art_2_label(),
          state: m.svc_agents_art_2_state(),
        },
        {
          detail: m.svc_agents_art_3_detail(),
          icon: "gmail",
          label: m.svc_agents_art_3_label(),
          state: m.svc_agents_art_3_state(),
        },
      ],
    },
    artNote: m.svc_agents_art_note(),
    capabilityId: "agent-teams",
    cta: { lede: m.svc_agents_cta_lede(), title: m.svc_agents_cta_title() },
    faq: [
      {
        answer: m.svc_agents_faq_1_answer(),
        question: m.svc_agents_faq_1_question(),
      },
      {
        answer: m.svc_agents_faq_2_answer(),
        question: m.svc_agents_faq_2_question(),
      },
      {
        answer: m.svc_agents_faq_3_answer(),
        question: m.svc_agents_faq_3_question(),
      },
      {
        answer: m.svc_agents_faq_4_answer(),
        question: m.svc_agents_faq_4_question(),
      },
    ],
    intro: m.svc_agents_intro(),
    keywords:
      "AI agent development, AI agent development company, custom AI agents, build custom AI agent, AI sales automation, AI lead generation automation, AI email automation, AI CRM automation, AI aģenti, AI aģentu izstrāde",
    label: m.svc_agents_label(),
    limits: {
      body: m.svc_agents_limits_body(),
      items: [
        {
          term: m.svc_agents_limit_1_term(),
          value: m.svc_agents_limit_1_value(),
        },
        {
          term: m.svc_agents_limit_2_term(),
          value: m.svc_agents_limit_2_value(),
        },
        {
          term: m.svc_agents_limit_3_term(),
          value: m.svc_agents_limit_3_value(),
        },
      ],
      title: m.svc_agents_limits_title(),
    },
    meta: {
      description: m.svc_agents_meta_description(),
      title: m.svc_agents_meta_title(),
    },
    nav: m.svc_agents_nav(),
    scope: {
      body: m.svc_agents_scope_body(),
      points: [
        m.svc_agents_scope_point_1(),
        m.svc_agents_scope_point_2(),
        m.svc_agents_scope_point_3(),
        m.svc_agents_scope_point_4(),
      ],
      title: m.svc_agents_scope_title(),
    },
    serviceType: "AI agent development",
    slug: "ai-agent-development",
    steps: {
      body: m.svc_agents_steps_body(),
      items: [
        m.svc_agents_step_1(),
        m.svc_agents_step_2(),
        m.svc_agents_step_3(),
        m.svc_agents_step_4(),
      ],
      title: m.svc_agents_steps_title(),
    },
    title: [m.svc_agents_title_1(), m.svc_agents_title_2()],
    uses: [
      { term: m.svc_agents_use_1_term(), value: m.svc_agents_use_1_value() },
      { term: m.svc_agents_use_2_term(), value: m.svc_agents_use_2_value() },
      { term: m.svc_agents_use_3_term(), value: m.svc_agents_use_3_value() },
      { term: m.svc_agents_use_4_term(), value: m.svc_agents_use_4_value() },
    ],
  };
}
